import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { User } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData: Partial<User>) => {
      const result = await apiClient.user.createUser.mutation({ body: userData });
      if (result.status !== 201) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users-list'] });
      toast.success('User created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating user!');
    },
  });
};
